















import { Component, Prop, Vue, Emit, Watch } from 'vue-property-decorator'

import { Lov } from '../models/lov'

@Component({
  components: { },
})
export default class CheckSheetDropdown extends Vue {

  @Prop() value:{is_checked:boolean, selected_item:string}
  @Prop() choices:Lov[];

  id:string = ""

  @Emit()
  input(value:object) { }

  mounted() {
    this.id = Math.random().toString(36).substr(2, 16)
    // init default value
    if (this.value != null && (this.value.is_checked == undefined || typeof this.value.selected_item !== 'string')) {
      this.input({
        is_checked: false,
        selected_item: ''
      })
    }
  }
}

